const meta = {
  auth: true
}

export default
  [
    {
      path: 'index',
      name: 'my-index',
      component: () => import('./index'),
      meta: {
        ...meta,
        title: '我的主页'
      }
    },
    {
      path: 'projects',
      name: 'my-projects',
      component: () => import('./projects'),
      meta: {
        ...meta,
        title: '我的项目'
      }
    },
    {
      path: 'profile',
      name: 'my-profile',
      component: () => import('./profile'),
      meta: {
        ...meta,
        title: '个人信息'
      }
    },
    {
      path: 'password',
      name: 'my-password',
      component: () => import('./password'),
      meta: {
        ...meta,
        title: '修改密码'
      }
    },
    {
      path: 'secret',
      name: 'my-secret',
      component: () => import('./secret'),
      meta: {
        ...meta,
        title: '秘钥管理'
      }
    },
    {
      path: 'message',
      name: 'my-message',
      component: () => import('./message'),
      meta: {
        ...meta,
        title: '通知消息'
      }
    },
    {
      path: 'task',
      name: 'my-task',
      component: () => import('./task'),
      meta: {
        ...meta,
        title: '后台任务'
      }
    }
  ]
